module.exports = __webpack_public_path__ + "static/media/Frame.29029622.png";